import * as types from './supportLoginLinkActionTypes';
import { supportLoginLinkEndpoint } from 'src/shared/app/base/settings/endpointSettings';

import { parseResponse } from 'src/shared/app/base/util/ajaxUtils';

export function sendLoginLinkWithUsername(
  username: string,
  eventId: number,
): any {
  return (dispatch: any, { post }: Object) => {
    dispatch(supportLoginLinkRequest());

    return post(supportLoginLinkEndpoint(eventId), {
      username,
    })
      .then(parseResponse)
      .then(() => {
        dispatch(supportLoginLinkSuccess(username));
      })
      .catch((exception) => {
        dispatch(supportLoginLinkFailure(exception));

        throw exception;
      });
  };
}

export function sendLoginLinkWithMembershipId(
  membershipId: number,
  eventId: number,
): any {
  return (dispatch: any, { post }: Object) => {
    dispatch(supportLoginLinkRequest());

    return post(supportLoginLinkEndpoint(eventId), {
      membership_id: membershipId,
    })
      .then(parseResponse)
      .then(() => {
        dispatch(supportLoginLinkSuccess(null, membershipId));
      })
      .catch((exception) => {
        dispatch(supportLoginLinkFailure(exception));

        throw exception;
      });
  };
}

export function supportLoginLinkRequest() {
  return {
    type: types.SUPPORT_LOGIN_LINK_REQUEST,
  };
}

export function supportLoginLinkFailure() {
  return {
    type: types.SUPPORT_LOGIN_LINK_FAILURE,
  };
}

export function supportLoginLinkSuccess(
  username?: string,
  membershipId: number,
) {
  let encryptedEmail;

  if (membershipId) {
    encryptedEmail = true;
  }
  return {
    type: types.SUPPORT_LOGIN_LINK_SUCCESS,
    encryptedEmail,
    username,
  };
}

export function resetSupportLoginLink() {
  return {
    type: types.RESET_SUPPORT_LOGIN_LINK,
  };
}

export function resendLoginLinkWithUsername(
  username: string,
  eventId: number,
): any {
  return (dispatch: any, { post }: Object) => {
    dispatch(resupportLoginLinkRequest());

    return post(supportLoginLinkEndpoint(eventId), {
      username,
    })
      .then(parseResponse)
      .then(() => {
        dispatch(resupportLoginLinkSuccess(username));
      })
      .catch((exception) => {
        dispatch(resupportLoginLinkFailure(exception));

        throw exception;
      });
  };
}

export function resendLoginLinkWithMembershipId(
  membershipId: number,
  eventId: number,
): any {
  return (dispatch: any, { post }: Object) => {
    dispatch(resupportLoginLinkRequest());

    return post(supportLoginLinkEndpoint(eventId), {
      membership_id: membershipId,
    })
      .then(parseResponse)
      .then(() => {
        dispatch(resupportLoginLinkSuccess(null, membershipId));
      })
      .catch((exception) => {
        dispatch(resupportLoginLinkFailure(exception));

        throw exception;
      });
  };
}

export function resupportLoginLinkRequest() {
  return {
    type: types.SUPPORT_RESEND_LOGIN_LINK_REQUEST,
  };
}

export function resupportLoginLinkFailure() {
  return {
    type: types.SUPPORT_RESEND_LOGIN_LINK_FAILURE,
  };
}

export function resupportLoginLinkSuccess(
  username?: string,
  membershipId: number,
) {
  let encryptedEmail;

  if (membershipId) {
    encryptedEmail = true;
  }
  return {
    type: types.SUPPORT_RESEND_LOGIN_LINK_SUCCESS,
    encryptedEmail,
    username,
  };
}
